import { render, staticRenderFns } from "./productoSeleccionadoCard.vue?vue&type=template&id=c5cec9fc&scoped=true"
import script from "./productoSeleccionadoCard.vue?vue&type=script&lang=js"
export * from "./productoSeleccionadoCard.vue?vue&type=script&lang=js"
import style0 from "./productoSeleccionadoCard.vue?vue&type=style&index=0&id=c5cec9fc&prod&scoped=true&lang=css"
import style1 from "./productoSeleccionadoCard.vue?vue&type=style&index=1&id=c5cec9fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5cec9fc",
  null
  
)

export default component.exports